import { render, staticRenderFns } from "./DashContent.vue?vue&type=template&id=24eb1d07&scoped=true&"
import script from "./DashContent.vue?vue&type=script&lang=js&"
export * from "./DashContent.vue?vue&type=script&lang=js&"
import style0 from "./DashContent.vue?vue&type=style&index=0&id=24eb1d07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eb1d07",
  null
  
)

export default component.exports